import { BlockType } from '../../types/index.js';
import { DividerBlock as Component } from './Block.js';
export const RegisteredDividerBlock = (_intl) => ({
    recommendedName: 'Divider',
    Component,
    config: {
        type: BlockType.Block,
        usable: false,
    },
});
//# sourceMappingURL=registered.js.map